// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/TreatmentSelect/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_Old_TreatmentSelect_Content($patient_id: uuid!) {
  vaxiom_patients(where: { _id: { _eq: $patient_id } }) {
    id
    _id
    tx_cards(
      where: { deleted: { _eq: false }, txs: { deleted: { _eq: false } } }
      order_by: { latest_appointment_booking_start_time: desc_nulls_last }
    ) {
      id
      _id
      name
      txs(where: { deleted: { _eq: false } }) {
        id
        _id
        name
        status
        tx_status_name {
          id
          name
        }
      }
    }
  }
}

`